import { Stack, Pagination } from "@mui/material"
import Div from "../../../components/Div";
import Input from "../../../components/Input";
import { useState, useEffect, useCallback } from "react";
import PageTitle from "../../../components/PageTitle";
import FormButton from "../../../components/FormButton";
import {
    getMonthlyRenewalData, getFollowUpComments, updateSegmentsHttp, updateZoneHttp, getAssignedToData,
    updateAssignedTo, getMonthlyRenewalExportData, // createRenewalInvoice, createRenewalProposal 
    updateBulkAssignedTo
} from "../../../http/renewalHttp/RenewalHttp";
import FollowupHistoryModal from "../../../components/Renewal/FollowupHistoryModal";
import AddCommentModal from "../../../components/Renewal/AddCommentModal";
import Select from "../../../components/Select";
import SendNotificationModal from "../../../components/Renewal/SendNotificationModal";
import { segments, zones, license_filter } from '../../../util/enum';
import { CiImport } from "react-icons/ci";
import { getSessionUser } from "../../../util/validation";
import UpdateRenewalDomainDetailModal from "../../../components/Renewal/UpdateRenewalDomainDetailModal";


export default function GetMonthlyRenewal() {

    const [customerList, setCustomerList] = useState([]);
    // const [isAscending, setIsAscending] = useState(true);
    const [initailCustomerList, setInitialCustomerList] = useState([])
    const [followupHistory, setFollowupHistory] = useState(false);
    const [sendNotification, setSendNotification] = useState(false);
    const [addComment, setAddComment] = useState(false);

    const [searchAssignedTo, setSearchAssignedTo] = useState('')
    const [segmentFilter, setSegmentFilter] = useState('')
    const [licenseFilter, setLicenseFilter] = useState('')
    const [bulkAssignement, setBulkAssignment] = useState(null)
    const [updateRenewalDomain, setUpdateRenewalDomain] = useState(false)

    const getCurrentYearMonth = () => {
        const date = new Date();
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    };

    const [month, setMonth] = useState(getCurrentYearMonth);

    const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });
    const [formattedMonth, setFormattedMonth] = useState(currentMonth);

    const [search, setSearch] = useState('')
    // const [sortColumn, setSortColumn] = useState(null);
    // const [sortOrder, setSortOrder] = useState("asc");


    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [assignedToList, setAssignedToList] = useState([]); // State to hold assigned users
    const [selectedAssignedTo, setSelectedAssignedTo] = useState({}); // State to track selected assigned user for each renewal

    const currentItems = customerList.slice(indexOfFirstItem, indexOfLastItem);


    // Calculate total pages
    const totalPages = Math.ceil(customerList.length / itemsPerPage);

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    const zone = zones.zone.map((zone) =>
        zone.id !== currentItems ?
            <option key={zone.id}
                name={zone.id}
                value={zone.id}>
                {zone.value}</option>
            : null);

    const license_filters = license_filter.license_filter.map((license_filter) =>
        license_filter.id !== currentItems ?
            <option key={license_filter.id}
                name={license_filter.id}
                value={license_filter.id}>
                {license_filter.value}</option>
            : null);

    // const yesnoOption = yesno.options.map((yesno) =>
    //     <option key={yesno.id}
    //         name={yesno.id}
    //         value={yesno.id}>
    //         {yesno.value}
    //     </option>
    // )

    const state = segments.segment.map((state) =>
        state.id !== currentItems ?
            <option key={state.id}
                name={state.id}
                value={state.id}>
                {state.value}</option>
            : null)


    const getMonthlyRenewal = useCallback(async (date) => {
        const response = await getMonthlyRenewalData(date)
        if (response) {
            console.log(response)
            setCustomerList(response.customer)
            setInitialCustomerList(response.customer)
            // setInitialCustomerList(response.customer)
        } else {
            setCustomerList([])
            setInitialCustomerList([])
        }
    }, [])

    const fetchAssignedUsers = useCallback(async () => {
        const response = await getAssignedToData()
        if (response) {
            console.log(response)
            const assigned_to_response = response.domain.map((state) =>

                <option key={state.assigned_to}
                    name={state.assigned_to}
                    value={state.assigned_to}>
                    {state.assigned_to}</option>
            )
            setAssignedToList(assigned_to_response)
            // setInitialCustomerList(response.customer)
        }
    }, []);

    useEffect(() => {
        const date = new Date()
        const currentYear = date.getFullYear(); // Get current year (YYYY)
        let currentMonth = (date.getMonth() + 1).toString(); // Get current month (1-12)

        // Ensure month is in MM format by adding a leading zero if needed
        if (currentMonth.length < 2) {
            currentMonth = '0' + currentMonth;
        }

        const formattedDate = `${currentYear}-${currentMonth}`; // Format as YYYY-MM

        getMonthlyRenewal(formattedDate)
        fetchAssignedUsers();
    }, [getMonthlyRenewal, fetchAssignedUsers])


    const handleAssignedToChange = (renewal_id, value) => {
        setSelectedAssignedTo(prev => ({ ...prev, [renewal_id]: value }));
    };

    const handleUpdateAssignedTo = async (renewal_id) => {
        if (selectedAssignedTo[renewal_id]) {
            try {
                const respones = await updateAssignedTo(renewal_id, selectedAssignedTo[renewal_id]);
                console.log(respones)
                if (respones) {
                    alert('Assigned To Updated Successfully')
                }
                // const response = await updateAssignedToHttp(renewal_id, selectedAssignedTo[renewal_id]); // Replace with your API call
                // if (!response.ok) {
                //     throw new Error(`HTTP error! status: ${response.status}`);
                // }
                // Handle successful update
            } catch (error) {
                console.error('Error updating assigned to:', error);
                alert('Failed to Update Assigned To. Please try refreshing the page');
            }
        }
    };


    async function handleFollowUp(renewal_id) {
        const followUpCommentResponse = await getFollowUpComments(renewal_id)
        // if (followUpCommentResponse){
        const followComments = {
            'renewal_id': renewal_id,
            'followupComments': followUpCommentResponse ? followUpCommentResponse.followup_comment : []
        }
        setFollowupHistory(followComments)

    }

    async function handleExport() {

        if (currentItems) {
            // console.log(month)
            const exportData = await getMonthlyRenewalExportData(month)

            // if (!Array.isArray(exportData) || exportData.length === 0) {
            //     console.error('Empty or invalid data received');
            //     return;
            // }
            if (exportData) {

                const headers = Object.keys(exportData.customer[0]); // column names
                const rows = exportData.customer;
                console.log(headers)
                // Convert header and rows to CSV strings
                const csvRows = [
                    headers.join(','), // header row
                    ...rows.map(row => headers.map(header => JSON.stringify(row[header] ?? '')).join(',')) // data rows
                ];

                const csv = csvRows.join('\n');

                // console.log(csv)
                const blob = new Blob([csv], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.setAttribute('href', url);
                a.setAttribute('download', 'data.csv');
                a.click();
            }
            else {
                return null;
            }
        }

    }

    const [selectedZone, setSelectedZone] = useState({});
    const [selectedSegment, setSelectedSegment] = useState({});

    const handleZoneChange = (renewal_id, value) => {
        setSelectedZone(prev => ({ ...prev, [renewal_id]: value }));
    };

    const handleSegmentChange = (renewal_id, value) => {
        setSelectedSegment(prev => ({ ...prev, [renewal_id]: value }));
    };

    const handleUpdateZone = async (renewal_id) => {
        if (selectedZone[renewal_id]) {
            const zoneResponse = await updateZoneHttp(renewal_id, selectedZone[renewal_id]);
            if (!zoneResponse) {
                alert('Failed to Update Zone. Please try refreshing the page');
            } else {
                alert('Zone Updated Successfully')
            }
        }
    };

    const handleUpdateSegment = async (renewal_id) => {
        if (selectedSegment[renewal_id]) {
            const segmentResponse = await updateSegmentsHttp(renewal_id, selectedSegment[renewal_id])
            if (!segmentResponse) {
                alert('Failed to Update Segment. Please try refreshing the page');
            } else {
                alert('Segment Updated Successfully')
            }
        }
    };

    function handleSendNotification(domain_name, renewal_id, subscription_id, renewal_date, zohoContactId) {
        const notifyData = {
            'domain_name': domain_name,
            'renewal_id': renewal_id,
            'subscription_id': subscription_id,
            'renewal_date': renewal_date,
            'zoho_contact_id': zohoContactId
        }
        setSendNotification(notifyData)
    }

    function handleAddComment(renewal_id) {

        setAddComment(renewal_id);

    }

    function handleMonthChange(event) {
        const month_item = event.target.value
        console.log(month_item)
        getMonthlyRenewal(month_item)
        let [year, month] = month_item.split("-").map(Number);

        // Adjust month (subtracting 1 to get the previous month)
        let prevMonthDate = new Date(year, month - 1); // `month - 2` because JS months are 0-based
        setFormattedMonth(prevMonthDate.toLocaleString('en-US', { month: 'long' }));
        setMonth(month_item)

    }

    const handleSort = (column) => {

        // let sortedList = [...initailCustomerList];

        // if (sortColumn === column) {
        //     sortedList.reverse(); // Toggle the sorting order
        //     setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        // } else {
        //     sortedList.sort((a, b) => {
        //         if (a[column] < b[column]) return -1;
        //         if (a[column] > b[column]) return 1;
        //         return 0;
        //     });
        //     setSortColumn(column);
        //     setSortOrder("asc");
        // }
        // console.log(sortedList)
        // setInitialCustomerList(sortedList);
    };

    function handleSearchCustomer(event) {

        const search_item = event.target.value;

        console.log(search_item)
        const filteredList = initailCustomerList.filter((customer) => {

            if ((customer && customer.domain_name)) {

                return customer.domain_name.toLowerCase().includes(search_item.toLowerCase());
            }
            else {
                return false
            }
        });
        console.log(searchAssignedTo)
        setCustomerList(filteredList);
        setSearch(search_item)

    }



    // function createInvoice(renewal_id){

    //     const response = createRenewalInvoice(renewal_id)
    //     console.log(response)

    // }

    // function createProposal(renewal_id){
    //     const response = createRenewalProposal(renewal_id)
    //     console.log(response)
    // }

    function handleLicenseFilter(event) {

        const search_item = event.target.value;
        console.log(search_item);
        if(segmentFilter){
            const filteredList = initailCustomerList.filter((customer) => {

                if ((customer && customer.segments)) {
    
                    return customer.segments.toLowerCase().includes(segmentFilter.toLowerCase());
                }
                else {
                    return false
                }
            });

            const segmentFilterList = filteredList.filter((customer) => {

                if ((customer && customer.number_of_seats)) {
    
                    if (search_item === '< 99') {
    
                        return customer.number_of_seats < 99;
    
                    }
    
                    else if (search_item === '100-300') {
                        return customer.number_of_seats > 99 && customer.number_of_seats < 300;
                    }
                    else if (search_item === '301-999') {
                        return customer.number_of_seats > 300 && customer.number_of_seats < 1000;;
                    }
                    else if (search_item === '1000+') {
                        return customer.number_of_seats > 1000;
                    }
                    else {
                        return false
                    }
    
                }
                else {
                    return false
                }
            });
            
            setCustomerList(segmentFilterList);


        }else{
        const filteredList = initailCustomerList.filter((customer) => {

            if ((customer && customer.number_of_seats)) {

                if (search_item === '< 99') {

                    return customer.number_of_seats < 99;

                }

                else if (search_item === '100-300') {
                    return customer.number_of_seats > 99 && customer.number_of_seats < 300;
                }
                else if (search_item === '301-999') {
                    return customer.number_of_seats > 300 && customer.number_of_seats < 1000;;
                }
                else if (search_item === '1000+') {
                    return customer.number_of_seats > 1000;
                }
                else {
                    return false
                }

            }
            else {
                return false
            }
        });
        setCustomerList(filteredList);
        setLicenseFilter(search_item)
    }
    }

    function handleSegmentFilter(event){
        
        const search_item = event.target.value;
        console.log(search_item);

        if (licenseFilter){
            const filteredList = initailCustomerList.filter((customer) => {

                if ((customer && customer.number_of_seats)) {
    
                    if (licenseFilter === '< 99') {
    
                        return customer.number_of_seats < 99;
    
                    }
    
                    else if (licenseFilter === '100-300') {
                        return customer.number_of_seats > 99 && customer.number_of_seats < 300;
                    }
                    else if (licenseFilter === '301-999') {
                        return customer.number_of_seats > 300 && customer.number_of_seats < 1000;;
                    }
                    else if (licenseFilter === '1000+') {
                        return customer.number_of_seats > 1000;
                    }
                    else {
                        return false
                    }
    
                }
                else {
                    return false
                }
            });

            const segmentFilterList = filteredList.filter((customer) => {

                if ((customer && customer.segments)) {
    
                    return customer.segments.toLowerCase().includes(search_item.toLowerCase());
                }
                else {
                    return false
                }
            })

            setCustomerList(segmentFilterList);

        }else{
        const filteredList = initailCustomerList.filter((customer) => {

            if ((customer && customer.segments)) {

                return customer.segments.toLowerCase().includes(search_item.toLowerCase());
            }
            else {
                return false
            }
        });
        setCustomerList(filteredList);
        setSegmentFilter(search_item)
    }
    }

    function handleFilterExport(){
        if (currentItems) {
            const array = [Object.keys(currentItems[0])].concat(currentItems);

            const csv = array.map(row => Object.values(row).toString()).join('\n');
            console.log(csv)
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('href', url);
            a.setAttribute('download', 'data.csv');
            a.click();
        }
        else {
            return null;
        }
    }

    function handleSearchAssignedTo(event) {

        const search_item = event.target.value;


        const filteredList = initailCustomerList.filter((customer) => {

            if ((customer && customer.assigned_to)) {

                return customer.assigned_to.toLowerCase().includes(search_item.toLowerCase());
            }
            else {
                return false
            }
        });
        setCustomerList(filteredList);
        setSearchAssignedTo(search_item)
    }

    function handleBulkAssignment(event){
        const file = event.target.files[0];
         if (!file) {
          console.error("No file selected.");
          return;
        }
    
        // ✅ If your API expects multipart/form-data:
        setBulkAssignment(file)

    }

    async function handleSubmitBulkAssignment(){
        
        const formData = new FormData()
        formData.append("file",bulkAssignement)
        formData.append("month", month)
        const result = await updateBulkAssignedTo(formData)
        if(result){
            alert("Assigned to Updated")
        }else{
            alert("Please check the subscription Id uploaded.")
        }
    }

    function handleUpdateDomainDetails(customer){
        
        setUpdateRenewalDomain(customer)
    }

    return (
        <>
            {updateRenewalDomain ? <UpdateRenewalDomainDetailModal customer_data={updateRenewalDomain} show={true.toString()} open handleClicked={setUpdateRenewalDomain} /> :null}
            {sendNotification ? <SendNotificationModal notify={sendNotification} show={true.toString()} open handleClicked={setSendNotification} /> : null}
            {addComment ? <AddCommentModal comments={addComment} show={true.toString()} open handleClicked={setAddComment} /> : null}
            {followupHistory ? <FollowupHistoryModal history={followupHistory} show={true.toString()} open handleClicked={setFollowupHistory} /> : null}
            <PageTitle title={`Monthly Renewal Data for ${formattedMonth}`} />
            <Div className="col-md-12">
                <Div className="page-header-toolbar">

                    <Div className="btn-group toolbar-item" role="group" >

                        <Input type='month' name='month' id='month' style={{ marginLeft: '50px' }} value={month}
                            onChange={handleMonthChange}
                        />

                    </Div>

                    <Div className="btn-group toolbar-item" role="group" >

                        <Input type='text' name='text' id='text' style={{ marginLeft: '50px' }} value={search}
                            onChange={handleSearchCustomer}
                        />
                       

                        <Select
                            name='assignedTo'
                            options={assignedToList ? assignedToList : null} // Adjust based on your API response structure
                            defaultValue="Search Assigned To" //Set default value
                            onChange={handleSearchAssignedTo}
                            // onChange={(e) => handleAssignedToChange(customer.renewal_id, e.target.value)}
                            style={{ width: 'auto', marginLeft: '50px' }}
                        />

                        <Select
                            name='license_filter'
                            options={license_filters} // Adjust based on your API response structure
                            defaultValue="Select License Filter" //Set default value
                            onChange={handleLicenseFilter}
                            // onChange={(e) => handleAssignedToChange(customer.renewal_id, e.target.value)}
                            style={{ width: 'auto', marginLeft: '50px' }}
                        />

                        <Select
                            name='segment_filter'
                            options={state ? state : null} // Adjust based on your API response structure
                            defaultValue="Select Segment Filter" //Set default value
                            onChange={handleSegmentFilter}
                           
                            // onChange={(e) => handleAssignedToChange(customer.renewal_id, e.target.value)}
                            style={{ width: 'auto', marginLeft: '50px' }}
                        />

                    </Div>


                    {getSessionUser === 'urmi.garmania@shivaami.com' || 'aashish.sakunde@dev.shivaami.in' ? <FormButton
                        className="btn btn-primary ml-2"
                        style={{ float: "right" }}
                        onClick={handleExport}
                        title="Export Reseller Data"
                    >
                        <CiImport size={15} />
                    </FormButton> : null}

                    
                     <FormButton
                        className="btn btn-primary ml-2"
                        style={{ float: "right" }}
                        onClick={handleFilterExport}
                        title="Export Reseller Data"
                    >
                        Export Filter data
                    </FormButton> 

                    <Input
                        type = 'file'
                        // className="btn btn-primary ml-2"
                        style={{ float: "right", margin: '10px' }}
                        onChange={handleBulkAssignment}
                        title="Export Reseller Data"
                    />
                       
                       <FormButton
                        className="btn btn-primary ml-2"
                        style={{ float: "right" }}
                        onClick={handleSubmitBulkAssignment}
                        title="Export Reseller Data"
                    >
                        Bulk Assignment
                    </FormButton> 

                    <Div className="filter-wrapper">
                    </Div>
                    {/* <span>
                        <Dropdown>
                            <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                                <BsFilter />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => handleStatusFilter('Active')}
                                >
                                    Active
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => handleStatusFilter('Rejected')}
                                >
                                    Rejected
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => handleStatusFilter('Suspended')}
                                >
                                    Suspended
                                </Dropdown.Item>

                            </Dropdown.Menu>

                        </Dropdown>

                    </span> */}
                </Div>
            </Div>

            <Div className="col-md-12 margin_top" style={{ opacity: '0.9' }} >
                {initailCustomerList.length > 0 ? <table className="table" border="1">
                    <thead>
                        <tr>
                            <th>Customer Domain</th>
                            <th>Reseller</th>
                            <th>Company Name</th>
                            <th>Plan</th>
                            <th>Status</th>
                            <th>Users</th>
                            <th>License</th>
                            <th>Sku Id</th>
                            <th>New Business Margin</th>
                            <th className="sortable-header"
                                onClick={() => handleSort("renewal_date")}
                            >Shivaami Renewal Date
                                {/* {sortColumn === "renewal_date" ? (
                                    sortOrder === "asc" ? (
                                        <FaSortUp className="sort-icon" />
                                    ) : (
                                        <FaSortDown className="sort-icon" />
                                    )
                                ) : (
                                    <FaSort className="sort-icon" /> // Default sort icon
                                )} */}
                            </th>
                            <th>Zone</th>
                            {/* <th>Commitment</th> */}
                            <th>Google Renewal Date</th>
                            <th>Price</th>
                            <th>Segments</th>
                            <th>Add Comment</th>
                            <th>Follow up History</th>
                            <th>Follow Up Comments</th>
                            <th>Highlighted Case Flag</th>
                            <th>Confirmation Status</th>
                            <th>Aggrement Status</th>
                            <th>Price Type</th>
                            <th>Upto 20</th>
                            <th>Above 20</th>
                            <th>Price Per User</th>
                            <th>Special Comment</th>
                            <th>Task Status</th>
                            <th>Renewed License</th>
                            <th>Extension Date</th>
                            <th>Support Charge</th>
                            <th>Suspension Reason</th>
                            <th>Customer Email</th>
                            <th>Assigned To</th>
                            <th>Update Domain Details</th>
                            <th></th>
                            
                        </tr>
                    </thead>
                    <tbody id="tableBody">
                        {currentItems.map((customer) =>

                            <tr key={customer.renewal_id}>
                                <td>
                                    {customer.domain_name}
                                    {/* <button onClick={()=>handlecustomerClick(customer.customer_id)} className="btn btn-link ">{customer.customer_name}</button> */}
                                </td>
                                <td>{customer.resellerType === 'Reseller' ? 'Y' : 'N'}</td>
                                <td>{customer.company_name}</td>
                                <td>{customer.plan_name}</td>
                                <td>{customer.status}</td>
                                <td>{customer.licensed_seats}</td>
                                <td>{customer.number_of_seats}</td>
                                <td>{customer.sku_name}</td>
                                <td>{customer.margin ? customer.margin + '%' : 'N/A'}</td>
                                <td>{customer.renewal_date}</td>
                                <td>
                                    <Select name='zone' options={zone} defaultValue={customer.zone}
                                        onChange={(e) => handleZoneChange(customer.renewal_id, e.target.value)}

                                        style={{ width: 'auto' }} />

                                    <Div className="d-flex gap-2 mt-2">
                                        <FormButton
                                            className="btn btn-primary btn-sm"
                                            onClick={() => handleUpdateZone(customer.renewal_id)}
                                        >
                                            Update
                                        </FormButton>
                                        {/* <FormButton
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => setSelectedZone(prev => ({ ...prev, [customer.renewal_id]: '' }))}
                                        >
                                            Cancel
                                        </FormButton> */}
                                    </Div>

                                </td>
                                {/* <td>
                                    <Select name='commitment' options={yesnoOption} defaultValue={customer.commitment}
                                        // onChange={(e) => handleZoneChange(customer.renewal_id, e.target.value)}

                                        style={{ width: 'auto' }} />

                                    <Div className="d-flex gap-2 mt-2">
                                        <FormButton
                                            className="btn btn-primary btn-sm"
                                            onClick={() => handleUpdateZone(customer.renewal_id)}
                                        >
                                              Update
                                        </FormButton>
                                    </Div>
                                </td> */}
                                <td>{customer.google_renewal_data}</td>
                                <td>{customer.price}</td>
                                <td>
                                    <Select name='user_status' options={state} defaultValue={customer.segments}
                                        onChange={(e) => handleSegmentChange(customer.renewal_id, e.target.value)}
                                        style={{ width: 'auto' }} />

                                    <Div className="d-flex gap-2 mt-2">
                                        <FormButton
                                            className="btn btn-primary btn-sm"
                                            onClick={() => handleUpdateSegment(customer.renewal_id)}
                                        >
                                            Update
                                        </FormButton>
                                        {/* <FormButton
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => setSelectedSegment(prev => ({ ...prev, [customer.renewal_id]: '' }))}

                                        >
                                            Cancel
                                        </FormButton> */}
                                    </Div>

                                </td>
                                <td>
                                    <FormButton
                                        type='button'
                                        className="btn btn-primary submit-btn btn-block"
                                        onClick={() => handleAddComment(customer.renewal_id)}
                                    >Add Comments</FormButton>
                                </td>

                                <td>
                                    <FormButton
                                        type='button'
                                        className="btn btn-primary submit-btn btn-block"
                                        onClick={() => handleFollowUp(customer.renewal_id)}
                                    >Follow up History</FormButton>
                                </td>
                                <td>{customer.followup_comments}</td>
                                <td>{customer.highlight_case}</td>
                                <td>{customer.confirmation_status}</td>
                                <td>
                                    {customer.agreement_status}
                                </td>
                                <td>{customer.priceType}</td>
                                <td>{customer.upto20}</td>
                                <td>{customer.above20}</td>
                                <td>{customer.price_per_user}</td>
                                <td>{customer.special_comments}</td>
                                <td>{customer.task_status ? customer.task_status : customer.reason}</td>
                                <td>{customer.renewed_lic}</td>
                                <td>{customer.extension_date}</td>
                                <td>{customer.assign}</td>
                                <td>{customer.suspension_reason}</td>
                                <td>{customer.customer_email}</td>
                                <td>  <Select
                                    name='assignedTo'
                                    options={assignedToList ? assignedToList : null} // Adjust based on your API response structure
                                    defaultValue={customer.assigned_to} //Set default value
                                    onChange={(e) => handleAssignedToChange(customer.renewal_id, e.target.value)}
                                    style={{ width: 'auto' }}
                                />

                                    <Div className="d-flex gap-2 mt-2">
                                        <FormButton
                                            className="btn btn-primary btn-sm"
                                            onClick={() => handleUpdateAssignedTo(customer.renewal_id)}
                                        >
                                            Update
                                        </FormButton>
                                    </Div>
                                </td>
                                
                                     <td>
                                    <FormButton
                                        type='button' 
                                        className="btn btn-primary btn-sm"
                                        onClick={() => handleUpdateDomainDetails(customer)}>
                                            Update Domain Details
                                        </FormButton>

                                
                                </td>
                                <td>
                                    <FormButton
                                        type='button'
                                        className="btn btn-link"
                                        onClick={() => handleSendNotification(customer.domain_name, customer.renewal_id, customer.subscription_id, customer.renewal_date, customer.zoho_customer_id)}
                                    >{customer.notification_status ? 'Sent Notification': 'Send Notification'}</FormButton>
                                    {/* <FormButton onClick = {()=> createInvoice(customer.renewal_id)}>
                                        Create invoice
                                    </FormButton>
                                    <FormButton onClick = {()=> createProposal(customer.renewal_id)}>
                                        Create Proposal
                                    </FormButton> */}
                                </td>
                               
                            </tr>
                        )

                        }
                    </tbody>
                </table> :
                    <>
                        <p style={{ marginTop: '30px' }}>No Domain Present or Could not fetch Domains</p>
                    </>}

                {currentItems.length > 0 ?
                    <Stack spacing={2}>
                        <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                        </Pagination>

                    </Stack> : null
                }
            </Div>

        </>
    )
}